import { render, staticRenderFns } from "./features.vue?vue&type=template&id=09cdb42e&"
import script from "./features.vue?vue&type=script&lang=ts&"
export * from "./features.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports